import { render, staticRenderFns } from "./StoreExceptionTypeStatistics.vue?vue&type=template&id=8cbf80d2&scoped=true&"
import script from "./StoreExceptionTypeStatistics.vue?vue&type=script&lang=js&"
export * from "./StoreExceptionTypeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./StoreExceptionTypeStatistics.vue?vue&type=style&index=0&id=8cbf80d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbf80d2",
  null
  
)

export default component.exports